import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import WithRender from './FlexiPayCheckOut.html';
import config from '@/settings/config.js';
import { CartLine, InitiatePayment, PaymentGateWay } from '@/types/CartTypes';
import { mapGetters } from 'vuex';

@WithRender
@Component({
  computed: {
    ...mapGetters("shoppingCart",
      { productInCart: "getCartLine" ,
      paymentGateWay: "getPaymentGateWayDto"},
      ),
  ...mapGetters("originatorStore", {originator:"getOriginator",currency:"getWalletCurrency"})
  },
  components: {
    Loading,
  },
})
export default class FlexiPayCheckOut extends Vue {
  currency!:string;
  productInCart!: CartLine;
  paymentGateWay!: PaymentGateWay;
  initiatePayment = {} as InitiatePayment;
  isLoading = false;
  fullPage = true;
  paymentMethod = "scode";
  ShowCouponBox = false;
 
  paymentTypes={
    singleButtonPaymentView:true,
    showWallet:false,
    showScode: false,
    showCoupon:false,
    showEFT:false,
    showCards: false
  }

  showPaymentMethods = !config.isMobile;
  private signingParty = "";

  payment!: {
    payfasturl: string;
  } | null;

  fee():number
  {
    return this.productInCart.totalLessSalesAmountFee as number
  }
  mounted() {
    this.IndividualPaymentsOff();
    if(this.productInCart.isoCountry.toLowerCase() === "zw")
    {
      this.IndividualPaymentsOnScodeOff();
    }
    if(this.productInCart.portiFolio.toLowerCase() === "busticket")
    {
      this.IndividualPaymentsOnScodeOff();
      this.paymentTypes.showScode = true;
    }
  }

  private IndividualPaymentsOnScodeOff()
  {
    this.paymentTypes.singleButtonPaymentView = false;
    this.paymentTypes.showWallet = true;
    this.paymentTypes.showScode = true;
    this.paymentTypes.showCoupon = true;
    this.paymentTypes.showCards =true;
    this.paymentTypes.showEFT = true;
  }

  private IndividualPaymentsOff()
  {
    this.paymentTypes.singleButtonPaymentView = false;
    this.paymentTypes.showWallet = false;
    this.paymentTypes.showScode = true;
    this.paymentTypes.showCoupon = false;
    this.paymentTypes.showCards =false;
    this.paymentTypes.showEFT = false;
  }

  private async preparePayment(signingParty: string) {
    this.isLoading = true;
    this.initiatePayment.rateKey = this.productInCart.key;
    this.initiatePayment.portfolio = this.productInCart.portiFolio;
    this.initiatePayment.recepientMobile = this.productInCart.receiveNumber;
    this.initiatePayment.accountNo = this.productInCart.accountNo;
    this.initiatePayment.senderMobile = this.productInCart.senderNumber;
    this.initiatePayment.signingParty = signingParty;
    this.initiatePayment.salesCurrencyAmount = this.productInCart.salesCurrencyAmount;
    this.initiatePayment.itemDescription = this.productInCart.description;
    this.initiatePayment.itemName = this.productInCart.itemName;
    this.initiatePayment.isoCountry = this.productInCart.isoCountry;
    this.initiatePayment.extra1 = this.productInCart.extra1;

    try {
      await this.$store.dispatch("shoppingCart/initiatePayment", this.initiatePayment);
      this.submitPayment(signingParty)
    }
    catch (error) {
      console.error(error);
    }
    this.isLoading = false;
  }

  GetPaymetURL() {
    if (this.payment == null)
      return;
    return this.payment.payfasturl + this.paymentMethod;
  }

  paymentMethodStrategy() {
    if (this.paymentMethod === "wallet") {
      this.preparePayment("wallet");
    }
    else if (this.paymentMethod === "scode") {
      this.preparePayment("scode");
    }
    else {
      this.preparePayment("payfast");
    }
  }

  private submitPayment(signingParty: string) {
    if (signingParty === "payfast")
      (<HTMLFormElement>document.querySelector("#payfast")).submit();
    else if(signingParty === "scode")
      this.$router.push("scodepayment");
    else
    this.$router.push("Credit");
  }
}